<template>
  <v-container fluid>
    <v-progress-linear
      :active="loading"
      height="3"
      class="my-0"
      :indeterminate="true"
    />
    <v-layout row py-0>
      <v-spacer />
      <v-btn icon :loading="loading" @click="fetchRanking(tournamentId)">
        <v-icon class="text--secondary"> refresh </v-icon>
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 py-3>
        <v-data-table
          :headers="headers"
          :items="ranking"
          :rows-per-page-items="[10, 25, 50]"
          class="elevation-1"
          item-key="_id"
          :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">
              {{ props.item.position }}
            </td>
            <td>
              <v-chip small color="transparent">
                <v-avatar size="32">
                  <img :src="props.item.logo" alt />
                </v-avatar>
                {{ props.item.name }}
              </v-chip>
            </td>
            <td class="text-xs-center">
              {{ props.item.playMatches }}
            </td>
            <td class="text-xs-center">
              {{ props.item.winMatches }}
            </td>
            <td class="text-xs-center">
              {{ props.item.tiedMatches }}
            </td>
            <td class="text-xs-center">
              {{ props.item.loseMatches }}
            </td>
            <td class="text-xs-center">
              {{ props.item.goalsFavor }}
            </td>
            <td class="text-xs-center">
              {{ props.item.goalsAgainst }}
            </td>
            <td class="text-xs-center">
              {{ props.item.goalDifference }}
            </td>
            <td class="text-xs-center">
              {{ props.item.points }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'TabClasification',

  computed: {
    ...mapState({
      tournamentId: (state) => state.tournaments.idSelected,
      ranking: (state) => state.tournaments.ranking,
      loading: (state) => state.tournaments.loading,
    }),
    headers() {
      return [
        {
          text: this.$t('titles.tournaments.position').toUpperCase(),
          value: 'position',

          align: 'center',
        },
        {
          text: this.$tc('models.team').toUpperCase(),
          value: 'name',
        },

        {
          text: 'PJ',
          value: 'playMatches',
          align: 'center',
        },
        {
          text: 'G',
          value: 'winMatches',
          align: 'center',
        },
        {
          text: 'E',
          value: 'tiedMatches',
          align: 'center',
        },
        {
          text: 'P',
          value: 'loseMatches',
          align: 'center',
        },
        {
          text: 'GF',
          value: 'goalsFavor',
          align: 'center',
        },
        {
          text: 'GC',
          value: 'goalsAgainst',
          align: 'center',
        },
        {
          text: 'DG',
          value: 'goalDifference',
          align: 'center',
        },
        {
          text: 'Pts',
          value: 'points',
          align: 'center',
        },
      ]
    },
  },
  methods: {
    ...mapActions({
      fetchRanking: 'tournaments/fetchRanking',
    }),
  },
}
</script>
